import PropTypes from 'prop-types';
import React, {Component} from 'react';
import NavLink from './NavLink';
import {defineMessages, FormattedMessage} from 'react-intl';
import {connectToStores} from 'fluxible-addons-react';
import FontAwesome from 'react-fontawesome';

const messages = defineMessages({
  account: {
    id: 'section.account',
    defaultMessage: 'My Account',
    description: 'The button text for the My Account link.'
  },
  logout: {
    id: 'section.account.logout',
    defaultMessage: 'logout',
    description: 'The button text for the logout link.'
  }
});

@connectToStores(['PortalUserStore'], (context) => {
  const PortalUserStore = context.getStore('PortalUserStore');

  return {
    name: PortalUserStore.getName(),
    title: PortalUserStore.getTitle(),
    clientName: PortalUserStore.getClientName()
  };
})
class AccountNav extends Component {
  static propTypes = {
    name: PropTypes.string,
    title: PropTypes.string,
    clientName: PropTypes.string
  };

  state = {
    opened: false
  };

  componentDidMount() {
    const bodyClicked = () => {
      const { opened } = this.state;
      if (opened) {
        this.setState({
          opened: false
        });
      }
    };

    this._eventListener = bodyClicked;

    document.addEventListener('click', bodyClicked);
  }

  componentWillUnmount() {
    const { _eventListener } = this;
    if (_eventListener) {
      document.removeEventListener('click', _eventListener);
    }
  }

  render() {
    const {name, title, clientName} = this.props;
    const { opened } = this.state || {};

    const menuClicked = (event) => {
      event.nativeEvent.stopImmediatePropagation();
      this.setState({
        opened: !opened
      });
    };

    const submenu = opened ? <div className='submenu flex-container flex-vertical text-right'>
      <NavLink to='/account/view' className='navbar-link vertical'>
        <FormattedMessage { ...messages.account } />
      </NavLink>
      <NavLink to='/account/logout' className='navbar-link vertical'>
        <FormattedMessage { ...messages.logout } />
      </NavLink>
    </div> : null;

    return <div className='flex-element flex-container'>
      <button className='flex-center action' role='button' onClick={ menuClicked }>
        { name }, { title } @ { clientName } <FontAwesome name='caret-down' />
      </button>
      { submenu }
    </div>;
  }
}

export default AccountNav;



// WEBPACK FOOTER //
// ./src/components/AccountNav.js